'use client'

import { useDebounce } from '@/hooks/use-debounce'
import { formatTwoDigits } from '@/utils/helpers'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Stack } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useEffect, useState } from 'react'
//updateCartItem
interface QuantityButtonProps {
  maxCount?: number
  init?: number
  onChange?: any
}
export const QuantityButton = ({ maxCount, init, onChange }: QuantityButtonProps) => {
  const [value, setValue] = useState(init ?? 0)
  const debounceValue = useDebounce(value, 300)
  const handlePlus = () => {
    if (maxCount && value >= maxCount) return
    setValue((prev) => prev + 1)
  }
  const handleMinus = () => {
    if (value <= 1) return
    setValue((prev) => prev - 1)
  }

  useEffect(() => {
    if (debounceValue !== 0 && debounceValue !== init) {
      onChange(debounceValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceValue])

  return (
    <Stack direction={'row'} alignItems="center" justifyContent={'center'} gap={2} sx={{border: "1px solid #e0e0e0", borderRadius: "4px", width: "fit-content", padding: "2px 6px ", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)"}}>
      <IconButton aria-label="minus" onClick={handleMinus} size="small">
        <RemoveIcon sx={{ color: '#3a3a3a' }} fontSize="small" />
      </IconButton>
      <div className="w-6 text-center font-semibold">{value == 0 ? value : formatTwoDigits(value)}</div>
      <IconButton aria-label="minus" onClick={handlePlus} size="small">
        <AddIcon sx={{ color: '#3a3a3a' }} fontSize="small" />
      </IconButton>
    </Stack>
  )
}
